/* Smelu Setpieces — per-section init, no globals */
(function () {
  /* Layout params by position index (0-based) — matches design spec */
  var LAYOUT = [
    { width: 220, up: 0,   shiftX: -8,  pinSide: 'left'  },
    { width: 195, up: 130, shiftX: 18,  pinSide: 'right' },
    { width: 185, up: 120, shiftX: -22, pinSide: 'left'  },
    { width: 170, up: 115, shiftX: 22,  pinSide: 'right' },
    { width: 195, up: 125, shiftX: -14, pinSide: 'left'  },
    { width: 235, up: 150, shiftX: 6,   pinSide: 'right' },
    { width: 245, up: 160, shiftX: -10, pinSide: 'left'  },
    { width: 185, up: 135, shiftX: 18,  pinSide: 'right' },
    { width: 215, up: 150, shiftX: -16, pinSide: 'left'  },
    { width: 190, up: 125, shiftX: 18,  pinSide: 'right' },
    { width: 190, up: 115, shiftX: -18, pinSide: 'left'  }
  ];

  var focusedInstance = null;

  function initSection(root, pieces) {
    var stack    = root.querySelector('[data-setpieces-stack]');
    var chipList = root.querySelector('[data-setpieces-chips]');
    var elName   = root.querySelector('[data-setpieces-name]');
    var elBlurb  = root.querySelector('[data-setpieces-blurb]');
    var elSpecs  = root.querySelector('[data-setpieces-specs]');
    var elStepC  = root.querySelector('[data-setpieces-step-cur]');
    var elStepT  = root.querySelector('[data-setpieces-step-tot]');
    var detail   = root.querySelector('[data-setpieces-detail]');
    // Prev/Next-Buttons wurden zugunsten eines Conversion-Hooks neben den Chips entfernt.
    // Die Chip-Nummern sind selbsterklärend genug; das spart Platz für den Funnel-Hint zur Material-Story.

    if (!stack || !chipList || !elName) return null;

    var active = -1;

    /* Build stack pieces */
    pieces.forEach(function (p, i) {
      var lay = LAYOUT[i] || { width: 200, up: 100, shiftX: 0, pinSide: 'right' };
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'smelu-piece smelu-piece--pin-' + (lay.pinSide === 'left' ? 'left' : 'right');
      btn.setAttribute('aria-label', p.idx + '. ' + p.name);
      btn.dataset.idx = i;
      btn.style.setProperty('--piece-w',  lay.width + 'px');
      btn.style.setProperty('--piece-up', lay.up + 'px');
      if (lay.shiftX) btn.style.setProperty('--piece-x', lay.shiftX + 'px');
      btn.innerHTML =
        '<img src="' + p.img + '" alt="" loading="lazy"/>' +
        '<span class="smelu-piece__pin" aria-hidden="true">' +
          '<span class="smelu-piece__line"></span>' +
          '<span class="smelu-piece__dot">' + p.idx + '</span>' +
        '</span>';
      btn.addEventListener('click', function () { setActive(i); focusedInstance = inst; root.setAttribute('data-touched', 'true'); });
      stack.appendChild(btn);
    });

    /* Build chip picker */
    pieces.forEach(function (p, i) {
      var li  = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'smelu-chip';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-label', p.name);
      btn.textContent = p.idx;
      btn.dataset.idx = i;
      btn.addEventListener('click', function () { setActive(i); focusedInstance = inst; root.setAttribute('data-touched', 'true'); });
      li.appendChild(btn);
      chipList.appendChild(li);
    });

    elStepT.textContent = String(pieces.length).padStart(2, '0');

    function setActive(i) {
      if (i < 0)              i = pieces.length - 1;
      if (i >= pieces.length) i = 0;
      if (i === active) return;
      active = i;

      var stackBtns = stack.querySelectorAll('.smelu-piece');
      var chips     = chipList.querySelectorAll('.smelu-chip');

      stackBtns.forEach(function (el, idx) {
        el.classList.toggle('is-active', idx === i);
      });
      chips.forEach(function (el, idx) {
        el.classList.toggle('is-active', idx === i);
        el.setAttribute('aria-selected', idx === i ? 'true' : 'false');
      });

      /* Detail crossfade */
      detail.classList.add('is-swapping');
      window.setTimeout(function () {
        var p = pieces[i];
        elName.textContent  = p.name;
        elBlurb.textContent = p.blurb;
        elStepC.textContent = String(p.idx).padStart(2, '0');
        elSpecs.innerHTML = p.specs.map(function (row) {
          return '<dt>' + row[0] + '</dt><dd>' + row[1] + '</dd>';
        }).join('');
        detail.classList.remove('is-swapping');
      }, 180);
    }

    // Prev/Next-Button-Handler entfernt (zugunsten Conversion-Hook). Keyboard-Pfeile/Home/End funktionieren weiterhin via Chips.

    var inst = { root: root, pieces: pieces, getActive: function () { return active; }, setActive: setActive };

    /* Activate first piece on init */
    setActive(0);
    return inst;
  }

  /* Init all setpieces sections on page */
  document.querySelectorAll('.smelu-setpieces[data-section-id]').forEach(function (root) {
    var sid    = root.dataset.sectionId;
    var pieces = window['SMELU_PIECES_' + sid];
    if (!pieces || !pieces.length) return;
    var inst = initSection(root, pieces);
    if (inst && !focusedInstance) focusedInstance = inst;
  });

  /* Global keyboard: ←/→ wrap cyclic, 1–9 jump, 0 → piece #10 */
  document.addEventListener('keydown', function (e) {
    if (!focusedInstance) return;
    if (e.target && e.target.closest && e.target.closest('input, textarea, [contenteditable]')) return;
    var inst = focusedInstance;
    if (e.key === 'ArrowLeft')       { inst.setActive(inst.getActive() - 1); }
    else if (e.key === 'ArrowRight') { inst.setActive(inst.getActive() + 1); }
    else if (/^[0-9]$/.test(e.key)) {
      var n   = parseInt(e.key, 10);
      var idx = n === 0 ? 9 : n - 1;
      if (idx < inst.pieces.length) inst.setActive(idx);
    }
  });
})();
